<template>
  <div class="wrapper" ref="wrapper">
    <div class="swiper home-box">
      <div class="swiper-wrapper">
        <!-- 首页 -->
        <div class="swiper-slide page1" v-if="true">
          <div class="page1-bg">
            <div class="content1">
              <div class="desc2">
                <div class="title_1">为全球用户提供</div>
                <div class="title_2">有价值的产品</div>
              </div>
            </div>

            <!-- 向下图标 -->
            <img src="@/assets/img/mobile/23.png" @click="downclick" class="png23" alt="">
          </div>
        </div>
        <!-- 九吨业务 -->
        <div class="swiper-slide page2" v-if="true">
          <Page2></Page2>
        </div>
        <!-- 九吨简介 -->
        <div class="swiper-slide page3">
          <Page3 ref="page3"></Page3>
        </div>
        <!-- 团队管理 -->
        <div class="swiper-slide page4">
          <Page4></Page4>
        </div>
        <!-- 九吨大事记 -->
        <div class="swiper-slide page5">
          <Page5></Page5>
        </div>
        <!-- 九吨新闻 -->
        <div class="swiper-slide page6">
          <Page6></Page6>
        </div>
        <!-- 九吨生活 -->
        <!-- <div class="swiper-slide page7" v-if="true">
          <Page7></Page7>
        </div> -->
        <!-- 加入九吨 -->
        <div class="swiper-slide page8">
          <Page8></Page8>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/js/swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import Page2 from './components/page2'
import Page3 from './components/page3'
import Page4 from './components/page4'
import Page5 from './components/page5'
import Page6 from './components/Page6'
// import Page7 from './components/Page7'
import Page8 from './components/Page8'
import { mapMutations, mapState } from "vuex";
export default {
  components: {
    Page2,
    Page3,
    Page4,
    Page5,
    Page6,
    // Page7,
    Page8
  },
  data() {
    return {
      swiperExa: null, // swiper 实例
    }
  },
  mounted() {
    this.getWindowConfig()
    // new VConsole()
    this.initSwiper();
  },
  computed: {
    ...mapState(['mobile_swiperIndex'])
  },
  watch: {
    mobile_swiperIndex: {
      handler: function (val) {
        // 保持在上一次的位置
        this.$nextTick(() => {
          this.swiperExa.slideTo(val, 0)
        })
      }, immediate: true
    }
  },
  methods: {
    ...mapMutations(['updareMobileSwiperIndex']),
    // 向下翻页
    downclick() {
      this.updareMobileSwiperIndex(this.mobile_swiperIndex + 1)
    },
    getWindowConfig() {
      let windowWidth = window.innerWidth;
      let windowHeight = window.innerHeight;
      if (typeof windowWidth !== 'number') {
        if (document.compatMode === 'CSS1Compat') {
          windowWidth = document.documentElement.clientWidth;
          windowHeight = document.documentElement.clientHeight;
        } else {
          windowWidth = document.body.clientWidth;
          windowHeight = window.body.clientHeight;
        }
      }
      this.$refs.wrapper.style = `height:${windowHeight}px`
      return {
        windowWidth: windowWidth,
        windowHeight: windowHeight
      }
    },
    initSwiper() {
      const _this = this
      this.swiperExa = new Swiper(".swiper", {
        direction: "vertical", // 垂直切换选项
        on: {
          // 当轮播切换的时候
          slideChange: function () {
            _this.updareMobileSwiperIndex(this.activeIndex)
            // 暂停简介模块的视频播放
            if (_this.$refs.page3) {
              _this.$refs.page3.pause()
            }
          },
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
.wrapper {
  overflow: hidden;
  // height: 100vh;


  .home-box {
    width: 100%;
    // background: red;
    height: 100%;

    .swiper-slide {
      position: relative;
      background: #FFF;
      padding: 1.76rem .5333rem 0 .5333rem;
      color: #000000;
      font-size: .2667rem;
      box-sizing: border-box;

      .downicon {
        width: .4533rem;
        height: .24rem;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        bottom: .8rem;
      }
    }

    .page1 {

      background-image: url(https://zhongtai-admin.oss-cn-hangzhou.aliyuncs.com/guanwang/h5_bg.jpeg);
      background-size: 100% 100%;
      position: relative;
      background-clip: abs;

      .page1-bg {
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;

        .png23 {
          width: .4267rem;
          // height: .3067rem;
          position: absolute;
          left: 50%;
          transform: translate(-50%);
          bottom: .4rem;
        }
      }

      .content1 {
        width: 4.9333rem;
        height: 9.8533rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-image: url(~@/assets/img/mobile/2.png);
        background-size: 100% 100%;
        padding-top: 1.04rem;
        box-sizing: border-box;

        .desc {
          color: rgba(255, 255, 255, 0.7);
          font-size: .6667rem;
          width: 7.9667rem;
          word-break: break-all;
          transform: translateX(-0.8rem);
          line-height: 1.0533rem;
          margin-bottom: .1333rem;
        }

        .desc2 {
          font-weight: 600;
          color: #fff;
          width: 7.9333rem;
          position: absolute;
          top: 10%;
          left: -15%;
          .title_1{
            font-size: .6667rem;
          }
          .title_2{
            font-size: 1.1333rem
          }
        }

      }
    }

    // .page2 {
    //   background: #FFF;
    //   padding: 1.76rem .5333rem 0 .5333rem;
    //   color: #000000;
    //   font-size: .2667rem;
    //   box-sizing: border-box;

    // }
    // .page3 {

    // }

  }
}
</style>